import { gqlClient } from '@/api/graphql-client';
import productSpecKeys from '@/api/queries/productSpecs/keyFactory';
import { graphql } from '@/gql';
import { ProductSpecCategory } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';

const ProductSpecsQuery = graphql(`
  query ProductSpecs($category: ProductSpecCategory!, $searchTerm: String) {
    productSpecs(category: $category, searchTerm: $searchTerm) {
      items {
        productSpec {
          id
          name
          category
          manufacturer
          modelNumber
          image {
            id
            url
          }
          domesticHotWaterLitres
          nominalOutputKw
          scopAtDefaultFlow
          panelCapacityW
          acOutputKw
          hybrid
          usableCapacityKwh
          soundPowerDbA
          type
          dimensions {
            heightMm
            widthMm
            depthMm
          }
        }
        appliance {
          id
        }
      }
      totalCount
    }
  }
`);

const useSearchProductSpecs = (
  category: ProductSpecCategory,
  searchTerm?: string
) => {
  const { data, ...rest } = useQuery({
    queryKey: productSpecKeys.search(category, searchTerm),
    queryFn: () => {
      return gqlClient.request(ProductSpecsQuery, {
        category,
        searchTerm: searchTerm || undefined,
      });
    },
    enabled: !!searchTerm,
  });

  return { data: data?.productSpecs?.items, ...rest };
};

export default useSearchProductSpecs;
